import { useMemo } from "react";

import {
  getInitialActiveWorkspaceId,
  getUserDefaultWorkspaceId,
  resolveActiveWorkspaceId,
} from "@/utils/activeWorkspace";
import { useCurrentUser } from "@/queries/users";
import { useWorkspaces } from "@/queries";

export const useOnboardingWorkspaceId = () => {
  const { data: currentUser } = useCurrentUser();
  const { data: workspacesData } = useWorkspaces();

  return useMemo(
    () =>
      resolveActiveWorkspaceId({
        workspaces: workspacesData?.workspaces ?? [],
        storedWorkspaceId: getInitialActiveWorkspaceId(),
        defaultWorkspaceId: getUserDefaultWorkspaceId(currentUser),
      }) ?? 0,
    [currentUser, workspacesData?.workspaces],
  );
};
